import { QueryClient } from "@tanstack/react-query";

export const rqClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: import.meta.env.PROD,
      throwOnError: (error) => {
        console.error(error);
        return false;
      },
      refetchOnWindowFocus: false,
    },
  },
});
